import { useEffect, useCallback } from 'react';

declare global {
  interface Window {
    googletag?: any;
  }
}

const adContainersIds: string[] = [];
const adSlot: Record<string, any> = {};

export function useGoogleAd(containerId: string) {
  const initAd = useCallback(() => {
    window.googletag = window.googletag || { cmd: [] };
    const { googletag } = window;

    if (adContainersIds.includes(containerId)) {
      googletag.cmd.push(() => {
        googletag.pubads().refresh([adSlot[containerId]]);
      });
      return;
    }

    adContainersIds.push(containerId);

    const adContainer = document.getElementById(containerId);
    if (!adContainer) return;

    const unitPath = `/3918296/${adContainer.getAttribute('data-dfp')}`;

    let sizes: string[];

    if (adContainer.hasAttribute('data-sizes')) {
      sizes = JSON.parse(adContainer.getAttribute('data-sizes'));
    } else {
      sizes = ['fluid'];
    }

    googletag.cmd.push(() => {
      adSlot[containerId] = googletag
        .defineSlot(unitPath, sizes, containerId)
        .addService(googletag.pubads());

      googletag.pubads().enableSingleRequest();
      googletag.enableServices();

      googletag.display(containerId);
    });
  }, [containerId]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
    script.async = true;
    script.onload = () => initAd();
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [initAd]);
}
